/**
 * Determines the S3 bucket URL based on the React application environment.
 *
 * The environment is determined using the `REACT_APP_ENV` environment variable.
 * Depending on the value of `REACT_APP_ENV`, the function returns the corresponding
 * S3 bucket URL for the specified environment.
 *
 * Supported environments:
 * - `development`: Returns the S3 bucket URL for the development environment.
 * - `testing`: Returns the S3 bucket URL for the testing environment.
 * - `production`: Returns the S3 bucket URL for the production environment.
 *
 * @constant {string} s3BucketUrl
 * @throws {Error} Throws an error if `REACT_APP
 */
const s3BucketUrl = (() => {
    switch (process.env.REACT_APP_ENV) {
        case 'development': {
            return 'https://pb-signatures-testing-bucket.s3.us-east-2.amazonaws.com'; // Development URL
        }
        case 'testing': {
            return 'https://pb-signatures-testing-bucket.s3.us-east-2.amazonaws.com'; // Testing URL
        }
        case 'production': {
            return 'https://pb-signatures-production-bucket.s3.us-east-2.amazonaws.com'; // Production URL
        }
        default: {
            throw new Error('Unrecognized React App Environment');
        }
    }
})();
export default s3BucketUrl;
